// extracted by mini-css-extract-plugin
export default {"rowHasBadge":"wD-z","smallCardRow":"xD-z","largeCardRow":"yD-z","productSearchRow":"zD-z","curatedRow":"AD-z"};